import i18n from '@dms/i18n';

import {FinancingDrafts} from '../types/FinancingDrafts';

/** Only template drafts get the confirmation hint — a manual draft has no template to apply. */
export function getFinancingPendingChangesTitle(drafts: FinancingDrafts) {
  const hasTemplateDraft = Object.values(drafts).some((draft) => draft?.mode === 'TEMPLATE');

  return hasTemplateDraft
    ? i18n.t('page.vehicle.financingAndLeasing.unsavedTemplateChanges')
    : i18n.t('general.notifications.unsavedChanges.title');
}
